<template>
  <section v-if="codeDetails">
    <h3>Code {{ codeDetails.code }}</h3>
    <p>
      <a
        class="text-primary"
        target="_blank"
        :href="codeDetails.shareUrl"
        data-testid="referral-code-url"
        >{{ codeDetails.shareUrl }}</a
      >
    </p>
    <SoDivider class="my-6" />
    <OpsReferralCodeToggleBlacklist :code-details="codeDetails" />
    <SoDivider class="my-6" />
    <h6 class="mb-3">
      Information of the customer who owns referral code
      <span class="font-weight-medium">{{ codeDetails.code }}</span
      >:
    </h6>
    <dl class="referral-details">
      <dt class="font-weight-medium mr-1">Name:</dt>
      <dd data-testid="referrer-name">
        {{ codeDetails.referrer.firstName }}
        {{ codeDetails.referrer.lastName }}
      </dd>

      <dt class="font-weight-medium mr-1">Email:</dt>
      <dd data-testid="referrer-email">{{ codeDetails.referrer.email }}</dd>

      <dt
        v-if="codeDetails.referrer.address?.formattedAddress"
        class="font-weight-medium mr-1"
      >
        Supply address:
      </dt>
      <dd data-testid="referrer-address">
        {{ codeDetails.referrer.address?.formattedAddress }}
      </dd>
    </dl>

    <SoDivider class="my-6" />
    <h4 class="mb-5">Referred customers</h4>
    <SoDataTable
      ref="referral-code-referred-list"
      :headers="referredTableHeaders"
      :items="referredList"
      :searchable="false"
      :has-pagination="false"
      no-data-text="No customer has been referred using this voucher yet"
    />
  </section>
  <SoAlert
    v-else-if="referralCodeQuery.isError"
    title="Failed to fetch code details"
    class="mb-5"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoDataTable from "@/components/dataTable/SoDataTable.vue"
  import SoDivider from "@/components/SoDivider.vue"
  import { SoDataTableHeader } from "@/types/components/SoDataTable"
  import SoAlert from "@/components/SoAlert.vue"
  import OpsReferralCodeToggleBlacklist from "@/views/operations/referrals/components/OpsReferralCodeToggleBlacklist.vue"
  import { ReferralService } from "@/services/operations/ReferralService"

  const referredTableHeaders: SoDataTableHeader[] = [
    {
      title: "Name",
      key: "name",
    },
    {
      title: "Credit Amount",
      key: "credit",
    },
    {
      title: "Refer-a-friend Credit Status",
      key: "status",
    },
  ]

  export default defineComponent({
    components: {
      SoDataTable,
      SoDivider,
      SoAlert,
      OpsReferralCodeToggleBlacklist,
    },
    data() {
      return {
        referredTableHeaders,
        referralCode: this.$route.params.referralCode,
      }
    },
    computed: {
      codeDetails() {
        return this.referralCodeQuery.data
      },
      referralCodeQuery() {
        return ReferralService.getReferralCodeDetails(
          this.referralCode as string,
        )
      },
      referredList() {
        return this.codeDetails
          ? this.codeDetails.referred.map((referred) => ({
              ...referred,
              name: `${referred.firstName} ${referred.lastName}`,
              credit: `£${referred.credit}`,
            }))
          : []
      },
    },
  })
</script>

<style scoped>
  .referral-details {
    display: grid;
    grid-template-columns: max-content auto;
  }
</style>
